import React from 'react'

// components
import Typography from '@mui/material/Typography'

const DiscountDetails = props => {
  const { children } = props

  return (
    <Typography
      variant='subtitle1'
      color='text.secondary'
      display='inline'
      ml={1}
    >
      {children}
    </Typography>
  )
}

export default DiscountDetails
